<div class="mst">
  @if (isRecursion()) {
    <div class="mst__row mst__row--recursion">
      @if (prefix(); as nr) {
        <span class="mst__step-nr">{{ nr }}</span>
      }
      <button
        type="button"
        class="mst__recursion"
        data-testid="module-step-recursive-hint"
        [attr.aria-label]="
          ('testCases.form.testSteps.editModuleAria' | translate) +
          ': ' +
          (recursionKey() | translate: { title: liveName() })
        "
        (click)="onRecursionOpen($event)"
        (keydown.enter)="onRecursionOpen($event)"
      >
        <mat-icon aria-hidden="true">autorenew</mat-icon>
        <span class="mst__recursion-text">{{ recursionKey() | translate: { title: liveName() } }}</span>
      </button>
    </div>
  } @else {
    <div
      class="mst__head"
      role="button"
      tabindex="0"
      [attr.aria-expanded]="expanded()"
      [attr.aria-label]="
        (expanded() ? 'testCases.form.testSteps.moduleCollapse' : 'testCases.form.testSteps.moduleExpand') | translate
      "
      (click)="toggle()"
      (keydown)="onHeaderKeydown($event)"
    >
      <mat-icon class="mst__chevron" [class.mst__chevron--expanded]="expanded()" aria-hidden="true">
        chevron_right
      </mat-icon>
      <mat-icon class="mst__icon" aria-hidden="true">extension</mat-icon>
      <span class="mst__name">{{ liveName() }}</span>
      @if (showStepKeys() && stepKey(); as key) {
        <app-step-key-pill [key]="key" />
      }
      @for (sheet of linkedSheets(); track sheet.id) {
        <span
          class="mst__tdb-chip"
          [attr.data-testid]="'nested-tdb-chip-' + sheet.key"
          [attr.title]="chipTooltip(sheet)"
        >
          <mat-icon class="mst__tdb-chip-icon" aria-hidden="true">table_chart</mat-icon>
          <code>{{ chipLabel(sheet) }}</code>
        </span>
      }
      @if (!readOnly()) {
        <button
          type="button"
          class="mst__edit"
          [class.mst__edit--no-right]="!canEditModule()"
          [attr.aria-label]="'testCases.form.testSteps.editModuleAria' | translate"
          [attr.aria-disabled]="canEditModule() ? null : 'true'"
          [attr.title]="canEditModule() ? null : ('testCases.form.testSteps.module.editNoRight' | translate)"
          (click)="onEditClick($event)"
          (keydown)="onEditKeydown($event)"
        >
          <mat-icon aria-hidden="true">edit</mat-icon>
          {{ 'testCases.form.testSteps.edit' | translate }}
        </button>
      }
      @if (stepCountKnown()) {
        <span class="mst__chip">
          {{ 'testCases.form.testSteps.moduleStepCount' | translate: { count: stepCount() } }}
        </span>
      }
      @if (submoduleCount() > 0) {
        <span class="mst__submodule-suffix">
          · {{ 'testCases.form.testSteps.moduleSubmoduleCountSuffix' | translate: { count: submoduleCount() } }}
        </span>
      }
    </div>

    @if (expanded()) {
      <div class="mst__body">
        @if (loading()) {
          <div class="mst__loading"><mat-spinner diameter="20" /></div>
        } @else if (error()) {
          <p class="mst__error" role="alert">
            {{ 'testCases.form.testSteps.moduleLoadError' | translate }}
            <button type="button" class="mst__retry" (click)="retry()">
              {{ 'testCases.form.testSteps.moduleLoadRetry' | translate }}
            </button>
          </p>
        } @else {
          @if (linkedSheets().length > 0) {
            <div class="mst__tdb-details">
              @for (sheet of linkedSheets(); track sheet.id) {
                <code class="mst__tdb-detail">{{ detailLabel(sheet) }}</code>
              }
            </div>
          }
          <p class="mst__hint">{{ 'testCases.form.testSteps.moduleReadonlyHint' | translate }}</p>
          <div class="mst__container">
            @for (inner of steps(); track inner.id; let i = $index) {
              @if (isModuleRef(inner) && inner.calledModuleId) {
                @if (childAncestors().length >= maxDepth) {
                  <div class="mst__truncated">{{ 'testCases.form.testSteps.moduleDepthLimit' | translate }}</div>
                } @else {
                  <app-module-step-tree
                    class="mst__child"
                    [projectId]="projectId()"
                    [moduleId]="inner.calledModuleId"
                    [name]="inner.title ?? ''"
                    [ancestors]="childAncestors()"
                    [prefix]="numberFor(i)"
                    [availableSheets]="availableSheets()"
                    [showStepKeys]="showStepKeys()"
                    [stepKey]="inner.key"
                    [readOnly]="readOnly()"
                    [canEditModule]="canEditModule()"
                    (editModule)="editModule.emit($event)"
                  />
                }
              } @else {
                <div class="mst__row" [class.mst__row--even]="i % 2 === 0">
                  <span class="mst__step-nr">{{ numberFor(i) }}</span>
                  <span class="mst__step-text">{{ inner.title || inner.action || '—' }}</span>
                  @if (showStepKeys() && inner.key; as key) {
                    <app-step-key-pill [key]="key" />
                  }
                </div>
              }
            } @empty {
              <p class="mst__empty">{{ 'testCases.form.testSteps.moduleEmpty' | translate }}</p>
            }
          </div>
        }
      </div>
    }
  }
</div>
